import React from 'react';

function Mission() {
  return (
    <div className="slds-grid slds-gutters">
      <div className="slds-col slds-size_1-of-1">
        <div className="slds-card">
          <div className="slds-card__body slds-card__body_inner">
            <h1 className="slds-text-heading_large slds-p-bottom_medium">Our Mission</h1>
            
            <div className="slds-text-longform">
              <div className="slds-p-bottom_medium">
                <h2 className="slds-text-heading_medium slds-p-bottom_small">Our Commitment</h2>
                <p className="slds-text-body_regular">
                  At Peak Autism Center, our mission is to empower individuals with autism spectrum disorder to reach their 
                  full potential through evidence-based Applied Behavior Analysis (ABA) therapy. We are committed to providing 
                  the highest quality of care and support to our clients and their families.
                </p>
              </div>

              <div className="slds-p-bottom_medium">
                <h2 className="slds-text-heading_medium slds-p-bottom_small">Our Vision</h2>
                <p className="slds-text-body_regular">
                  We envision a world where every individual with autism has access to effective, personalized therapy that 
                  enables them to lead fulfilling, independent lives. Through our dedication to excellence in ABA therapy, 
                  we strive to make this vision a reality for each of our clients.
                </p>
              </div>

              <div className="slds-grid slds-gutters slds-p-bottom_medium">
                <div className="slds-col slds-size_1-of-3">
                  <div className="slds-card">
                    <div className="slds-card__body slds-card__body_inner">
                      <h3 className="slds-text-heading_small slds-p-bottom_small">Excellence</h3>
                      <p className="slds-text-body_regular">
                        We maintain the highest standards in ABA therapy delivery and professional development.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="slds-col slds-size_1-of-3">
                  <div className="slds-card">
                    <div className="slds-card__body slds-card__body_inner">
                      <h3 className="slds-text-heading_small slds-p-bottom_small">Compassion</h3>
                      <p className="slds-text-body_regular">
                        We approach each client with understanding, respect, and genuine care for their well-being.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="slds-col slds-size_1-of-3">
                  <div className="slds-card">
                    <div className="slds-card__body slds-card__body_inner">
                      <h3 className="slds-text-heading_small slds-p-bottom_small">Innovation</h3>
                      <p className="slds-text-body_regular">
                        We continuously seek to improve our methods and incorporate the latest research in ABA therapy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="slds-p-bottom_medium">
                <h2 className="slds-text-heading_medium slds-p-bottom_small">Our Impact</h2>
                <p className="slds-text-body_regular">
                  Through our evidence-based approach and dedicated team of professionals, we have helped numerous 
                  individuals with autism develop essential life skills, improve communication, and achieve greater 
                  independence. Our success is measured by the progress and happiness of our clients and their families.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mission; 